// React for Website

import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
//outsource
import { Row, Col, Button } from "antd";

//components
import VoucherSearch from "./voucher_search";

const VoucherControl = ({ data, setSearch }) => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const handleClick = () => {
    const href = `/branchs/detail/${id}/voucher/add`;
    navigate(href);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderTotal = () => {
    return (
      <div>
        <span style={{ marginRight: 20, fontWeight: "bold" }}>
          Total: {data?.length || 0}
        </span>
        <Button type="primary" onClick={handleClick}>
          New Mkt Campaign
        </Button>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row style={{ alignItem: "center" }}>
      <Col xl={2} lg={2} md={4} xs={12}>
        <div className="voucher-header">Voucher</div>
      </Col>
      <Col xl={10} lg={10} md={8} xs={12}>
        <VoucherSearch data={data} setSearch={setSearch} />
      </Col>
      <Col align="right" xl={12} lg={12} md={12} xs={12}>
        {renderTotal()}
      </Col>
    </Row>
  );
};

export default VoucherControl;
